export default "__VITE_ASSET__BE_vFK5___"